import {
  UPDATE_EVENT,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_ERROR,
  UPDATE_EVENT_CLEAN,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  event: undefined,
}

const EventUpdate = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_EVENT:
      state = {
        ...state,
        loading: true,
      }
      break
    case UPDATE_EVENT_SUCCESS:
      state = {
        ...state,
        event: action.payload.event,
        loading: false,
        done: true,
      }
      break
    case UPDATE_EVENT_ERROR:
      state = {
        ...state,
        error: action.payload,
        event: undefined,
        loading: false,
        done: false,
      }
      break
    case UPDATE_EVENT_CLEAN:
      state = initialState
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default EventUpdate
